module.exports = __webpack_public_path__ + "img/avp_bck_alt_small@2x.dde7d78.webp";